// extracted by mini-css-extract-plugin
export default {"task-container":"JWERQ","name-input":"zTNqu"};